import { render } from "./Download.svg?vue&type=template&id=1368ffa4"
const script = {}
script.render = render

export default script